import { CSSResultGroup, html, TemplateResult } from 'lit';
import { OutlineModal } from 'src/components/base/outline-modal/outline-modal';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import componentStyles from './idb-bio-card-modal.css.lit';

/**
 * The IdbBioCardModal component
 * @element idb-bio-card-modal
 */
@customElement('idb-bio-card-modal')
export class IdbBioCardModal extends OutlineModal {
  static styles: CSSResultGroup = [OutlineModal.styles, componentStyles];

  /**
   * The ID of the Modal to pair with the corresponding BioCard
   */
  @property({ type: String, attribute: 'modal-id' })
  modalId: string;

  /**
   */
  @property({ type: String, attribute: 'heading' })
  heading: string;

  _hasSocialSlot: boolean;

  connectedCallback(): void {
    super.connectedCallback();
    document.addEventListener('modal-open', e =>
      this.handleModalOpenEvent(e as CustomEvent)
    );
  }

  _handleSlotChange(): void {
    this._hasHeaderSlot =
      this.querySelector('[slot="outline-modal--header"]') !== null;
    this._hasSocialSlot = this.querySelector('[slot="social-links"]') !== null;
    this._hasAccessibilityDescriptionSlot =
      this.querySelector(
        '[slot="outline-modal--accessibility-description"]'
      ) !== null;
  }

  disconnectedCallback(): void {
    document.removeEventListener('modal-open', e =>
      this.handleModalOpenEvent(e as CustomEvent)
    );
  }

  _overlayTemplate(): TemplateResult {
    let template = html``;

    if (this.isOpen) {
      template = html`
        <div
          id="overlay"
          tabindex="-1"
          class="${this.size}"
          @click="${this._handleOverlayClick}"
          @keydown="${this._handleOverlayKeydown}"
        >
          <div
            id="container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="header"
            aria-describedby="${ifDefined(
              this._hasAccessibilityDescriptionSlot
                ? 'accessibility-description'
                : undefined
            )}"
          >
            <div id="header">
              <h3 class="heading">${this.heading}</h3>              
                ${
                  this.shouldForceAction
                    ? null
                    : html`
                      <button
                        id="close"
                        aria-label="Close modal"
                        @click="${this.close}"
                        @keydown="${this._handleCloseKeydown}"
                      ></button>
                    `
                }
                          <slot
                id="title"
                name="social-links"
                @slotchange="${this._handleSlotChange}"
              ></slot>
            </div>
            <div id="main">
              <slot></slot>
            </div>
          </div>
        </div>
        <slot
          id="accessibility-description"
          name="outline-modal--accessibility-description"
          @slotchange="${this._handleSlotChange}"
        ></slot>
      `;
    }

    return template;
  }

  handleModalOpenEvent(event: CustomEvent): void {
    if (event.detail.id === this.modalId) {
      this.open();
    }
  }
}
